import React from 'react';
import { TAILWIND_CLASSES } from '../../Constants/theme';

/**
 * A container component for forms with consistent styling
 */
const FormContainer = ({
  children,
  title,
  subtitle,
  onSubmit,
  className = '',
  maxWidth = 'max-w-xl',
  icon = null,
  actions = null,
  loading = false,
}) => {
  return (
    <div className={`w-full ${maxWidth} ${maxWidth === 'max-w-full' ? '' : 'mx-auto'} bg-white rounded-xl shadow-md overflow-hidden ${className}`}>
      {/* Form Header */}
      {(title || subtitle) && (
        <div className="p-2 border-b border-gray-200">
          {title && (
            <div className="flex items-center gap-2 mb-1">
              {icon && <span className="text-primary">{icon}</span>}
              <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
            </div>
          )}
          {subtitle && <p className="text-gray-600">{subtitle}</p>}
        </div>
      )}
      
      {/* Form Body */}
      <div className={`p-3 ${loading ? 'opacity-70' : ''}`}>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-10 rounded-xl">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
          </div>
        )}
        <form onSubmit={onSubmit}>
          {children}
          
          {/* Form Actions */}
          {actions && (
            <div className="mt-6 flex items-center justify-end gap-3">
              {actions}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default FormContainer; 